<template>
  <div>
    <create-certificate-navigation :steps="steps" :currentStep="currentStep"></create-certificate-navigation>

    <transition name="fade" mode="out-in">
      <router-view :certificateType="certificateType" :certificateSource="certificateSource"></router-view>
    </transition>

    <need-inspiration-component />
  </div>
</template>
<script>
import NeedInspirationComponent from "../../components/NeedInspirationComponent";
import CreateCertificateNavigation from "../../components/wizard/WizardNavigation";

export default {
  name: "CreateCertificateWizard",
  computed: {
    certificateType() {
      return this.$store.getters["certificateWizard/getLastKnownCertificateType"];
    },
    certificateSource() {
      return this.$store.getters["certificateWizard/getLastKnownCertificateSource"];
    },
    currentStep() {
      return this.$route.meta.currentStep;
    },
    step1() {
      return {
        id: 1,
        text: this.$t("lang.label_certificate_type"),
        link: "/certificate/create/",
        disabled: false
      };
    },
    step2() {
      return {
        id: 2,
        text: this.$t("lang.label_certificate_source"),
        link: "/certificate/create/{type}".replace("{type}", this.certificateType),
        disabled: !this.certificateType
      };
    },
    step3() {
      return {
        id: 3,
        text: this.$t("lang.label_certificate_request"),
        link: "/certificate/create/{type}/{source}".replace("{type}", this.certificateType).replace("{source}", this.certificateSource),
        disabled: !this.certificateType || !this.certificateSource
      };
    },
    steps() {
      return [this.step1, this.step2, this.step3];
    }
  },
  updated() {
    // e.g. {type: "traditional", source: "from-new-keypair"}
    const routeMeta = {
      type: this.$route.meta.type,
      source: this.$route.meta.source
    };
    this.$store.dispatch("certificateWizard/updateFromRouteMeta", routeMeta);
  },
  components: {
    CreateCertificateNavigation,
    NeedInspirationComponent
  }
};
</script>
<style scoped></style>
